import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { fetchInitialDriverData } from "../services/driverMapService";

export const useDriverMapSocket = () => {
  const dispatch = useDispatch();

  // Memoize to prevent infinite re-renders
  const requestDriverData = useCallback(() => {
    fetchInitialDriverData(dispatch as any);
  }, [dispatch]);

  return {
    requestDriverData,
  };
};
